//noinspection JSUnusedLocalSymbols,JSUnresolvedReference

const TOO_MANY_MEDS = "Too many meds";
const EXPENSIVE = "Expensive";

function decodeHtml(html) {
  let element = document.createElement("textarea");
  element.innerHTML = html;
  return element.value;
}

const $inject = [
  "$scope",
  "$sce",
  "$interval",
  "$rootScope",
  "$state",
  "$stateParams",
  "$timeout",
  "$uibModal",
  "CommonData",
  "DefaultDateService",
  "eCryptService",
  "FormatService",
  "HmrService",
  "MessageService",
  "PhpPolyfillObject",
  "UndefinedDataService",
  "ValidateService",
];

/**
 * Handle HMR Report interface
 */
class HmrController {
  constructor(
    $scope,
    $sce,
    $interval,
    $rootScope,
    $state,
    $stateParams,
    $timeout,
    $uibModal,
    CommonData,
    DefaultDateService,
    eCryptService,
    FormatService,
    HmrService,
    MessageService,
    PhpPolyfillObject,
    UndefinedDataService,
    ValidateService
  ) {
    // Scope
    var self = this;

    // Components and classes
    this.$scope = $scope;
    this.$sce = $sce;
    this.$interval = $interval;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.$timeout = $timeout;
    this.uibModal = $uibModal;
    this.CommonData = CommonData;
    this.eCryptService = eCryptService;
    this.format = FormatService;
    this.hmrService = HmrService;
    /** @var {MessageService} */
    this.messageService = MessageService;
    this.PhpPolyfillObject = PhpPolyfillObject;
    this.UndefinedDataService = UndefinedDataService;
    this.validate = ValidateService;
    this.countdownInterval = undefined;
    this.on_page = true;

    $scope.refund_modal = {
      open: false,
    };

    $scope.show_toast = function ($message, $class) {
      $rootScope.$emit("display-toast", $message, $class);
    };

    $scope.hide_toast = function () {
      $rootScope.$emit("remove-toast");
    };

    // TODO Split this controller into one controller per page and move common code to a service.
    //   Remove this $locationChangeStart function when the controller is split.
    $rootScope.$on('$locationChangeStart', function () {
      if (self.countdownInterval) {
        $interval.cancel(self.countdownInterval);
      }
      $rootScope.$emit("remove-toast");
      self.on_page = false;
    });

    $scope.states = CommonData.STATES;
    $scope.titles = CommonData.TITLES;
    $scope.titles_with_blank = CommonData.TITLES.slice();
    $scope.titles_with_blank.push("");
    $scope.connection_status = "NOT_ESTABLISHED";

    // Configuration
    this.debug = true;
    this.savingInterval = 15 * 1000; // Milliseconds
    this.saving = false;
    this.submitted = false;
    this.loadingSubmit = false;
    this.success = false;
    this.message = null;
    this.savingQueue = [];
    this.keepSaving = true;

    // HMR report parameters and default values
    this.hmr_external_id = this.$stateParams.hmr_external_id;
    this.tandc = false;
    this.encryptedCvn = null;
    this.form = null;

    // TODO Remove the `hmr` field from the controller and only use it from the scope
    // Initialise the HMR object...
    this.hmr = {
      externalId: this.$stateParams.hmr_external_id,
      referral: null,
      hmrReport: {
        otherConcern: null,
        hmrReportMedications: [],
        hmrReportIssues: [],
      },
    };
    this.$scope.hmr = this.hmr;
    this.$scope.data_status = "NOT_LOADED";
    this.$scope.retry_attempts = 0;
    // ...and fill it with the information from the database
    this.get();

    this.concerns = {};

    // Datepicker
    this.datepickerStatus = {
      opened: false,
    };

    this.dateOfBirthDatepickerStatus = {
      opened: false,
    };

    var earliest_date = new Date();
    earliest_date.setMonth(earliest_date.getMonth() - 3);
    $scope.dateOptions = {
      minDate: earliest_date,
      maxDate: new Date(),
    };

    $scope.dateOfBirthDateOptions = {
      minDate: DefaultDateService.earliest_date_of_birth(),
      maxDate: new Date(),
      initDate: DefaultDateService.default_date_of_birth(),
    };
  }

  /**
   * Open the DatePicker
   * @param $event
   */
  openDatepicker($event) {
    this.datepickerStatus.opened = true;
  }

  openDateOfBirthDatepicker($event) {
    this.dateOfBirthDatepickerStatus.opened = true;
  }

  /**
   * In editing mode, save regularly
   */
  startEditing() {
    // Scope
    var self = this;

    self.concerns = {};
    if (!self.hmr.hmrReport) {
      self.hmr.hmrReport = {
        otherConcern: null,
        hmrReportMedications: [],
        hmrReportIssues: [],
      };
    }
    else {
      var concerns = self.hmr.hmrReport.patientConcerns;
      if (concerns.length === 0) {
        self.concerns.none = true;
      }
      else {
        for (var i = 0; i < concerns.length; i++) {
          if (concerns[i].description === TOO_MANY_MEDS) {
            self.concerns.tooManyMeds = true;
          }
          else if (concerns[i].description === EXPENSIVE) {
            self.concerns.expensive = true;
          }
        }
      }

      if (self.hmr.hmrReport.otherConcern) {
        // This supposes only one other concern can be written for one report
        // TODO Discuss whether multiple 'other' concerns should be catered for
        self.concerns.other = true;
        self.concerns.otherInput = self.hmr.hmrReport.otherConcern;
      }
    }

    // Cancel the automatic saving feature when leaving the page
    this.$scope.$on("$destroy", function () {
      if (self.keepSaving) {
        self.save();
      }
      if (self.promise) {
        self.$interval.cancel(self.promise);
      }
    });

    // Get the eCrypt encrypting functions
    this.eCryptService.load();

    // Automatic saving feature
    this.promise = this.$interval(function () {
      if (self.keepSaving) {
        if (!self.hmr.has_complete_patient_details) {
          self.save_patient_and_gp_details();
        }
        else {
          self.save();
        }
      }
    }, this.savingInterval);
  }

  /**
   * Get the data available for this HMR
   */
  get() {
    var self = this;

    var handleSuccess = function (response) {
      if (response.data.error) {
        handleError(response);
      }
      else {
        self.$scope.hide_toast();
        self.hmr = response.data.data.hmr;
        self.$scope.hmr = self.hmr;
        self.$scope.patient_display = {
          name: self.patient_display_name(),
          address: self.patient_display_address(),
        };
        if (!response.data.data.hmr.hmrReport.dose_administration_aid) {
          response.data.data.hmr.hmrReport.dose_administration_aid = {
            has_daa: null,
            daa_type: null,
            has_more_daa_info_benefit: null,
          };
        }
        self.$scope.dose_administration_aid = response.data.data.hmr.hmrReport.dose_administration_aid;
        let hmr = self.hmr;
        self.$scope.data_status = "LOADED";

        if (hmr) {
          if (self.hmr.referral) {
            if (!hmr.referral.patientCity) {
              hmr.referral.patientCity = hmr.patientPostcode;
            }

            if (self.hmr.referral.patientDob) {
              self.hmr.referral.patientDob = new Date(self.hmr.referral.patientDob);
            }

            if (hmr.referral.patientMedicare) {
              hmr.referral.patientMedicare = self.format.medicare(hmr.referral.patientMedicare);
            }

            if (hmr.referral.patientPhone) {
              hmr.referral.patientPhone = self.format.phone(hmr.referral.patientPhone);
            }

            if (hmr.referral.patientPhoneBusiness) {
              hmr.referral.patientPhoneBusiness = self.format.phone(hmr.referral.patientPhoneBusiness);
            }
          }

          if (self.hmr.dateOfLodgement) {
            self.hmr.dateOfLodgement = new Date(self.hmr.dateOfLodgement);
          }

          if (self.hmr.hmrReport && self.hmr.hmrReport.dateConducted) {
            self.hmr.hmrReport.dateConducted = new Date(self.hmr.hmrReport.dateConducted);
          }

          if (self.hmr.status) {
            self.product_prices = {};
            for (let price of self.hmr.assignedPharmacist.prices) {
              if (!self.product_prices[price.product.referral_type.code]) {
                self.product_prices[price.product.referral_type.code] = {};
              }

              self.product_prices[price.product.referral_type.code][price.product.product_component.code] = +price.price;
            }

            self.hmr.patientDetailsCorrect = false;
            self.hmr.gpDetailsCorrect = false;

            if (self.hmr.status.editable) {
              // If in the report page and in editable mode, start editing
              if (self.$state.current.name === "app.report") {
                self.startEditing();
              }
            }
            else {
              var refValue = self.hmr.hmrReport.reasonForReferral? self.hmr.hmrReport.reasonForReferral.replace(/\n/g, "<br/>"): "";
              self.hmr.hmrReport.reasonForReferral = self.$sce.trustAsHtml(refValue);
              for (var i = 0; i < self.hmr.hmrReport.patientConcerns.length; i++) {
                if (self.hmr.hmrReport.patientConcerns[i].description) {
                  refValue = self.hmr.hmrReport.patientConcerns[i].description? self.hmr.hmrReport.patientConcerns[i].description.replace(/\n/g, "<br/>"): "";
                  self.hmr.hmrReport.patientConcerns[i].description = self.$sce.trustAsHtml(refValue);
                }
              }
              for (var j = 0; j < self.hmr.hmrReport.hmrReportIssues.length; j++) {
                if (self.hmr.hmrReport.hmrReportIssues[j].issue) {
                  refValue = self.hmr.hmrReport.hmrReportIssues[j].issue? self.hmr.hmrReport.hmrReportIssues[j].issue.replace(/\n/g, "<br/>"): "";
                  self.hmr.hmrReport.hmrReportIssues[j].issue = self.$sce.trustAsHtml(refValue);
                }
                if (self.hmr.hmrReport.hmrReportIssues[j].action) {
                  refValue = self.hmr.hmrReport.hmrReportIssues[j].action? self.hmr.hmrReport.hmrReportIssues[j].action.replace(/\n/g, "<br/>"): "";
                  self.hmr.hmrReport.hmrReportIssues[j].action = self.$sce.trustAsHtml(refValue);
                }
              }
            }
          }

          self.practice_address = self.get_practice_address(hmr);
          self.gp_contact = self.get_gp_contact(hmr.referral);
        }
      }
    };

    var handleError = function (response) {
      self.$scope.data_status = "ERROR";
      if (self.on_page && self.$scope.retry_attempts <= 14) {
        let seconds = Math.pow(2, self.$scope.retry_attempts);
        self.$scope.delay = seconds * 3600 / 4096;

        if (self.$scope.delay % 1) {
          self.$scope.delay = seconds * 60 / 64;
        }

        if (self.$scope.delay % 1) {
          self.$scope.delay = seconds;
        }

        if (self.$scope.delay > 600) {
          self.$scope.connection_status = "FAILED";
          self.show_message("");
        }
        else {
          if (self.$scope.delay > 120) {
            self.$scope.connection_status = "UNSTABLE";
          }
          else {
            self.$scope.connection_status = "SLOW";
          }

          self.show_message();

          self.countdownInterval = self.$interval(function () {
            self.$scope.delay--;
            if (self.$scope.delay > 0) {
              self.show_message();
            }
            else {
              self.$scope.show_toast("Retrying …", "alert-info");
              self.$interval.cancel(self.countdownInterval);
              self.get();
            }
          }, 1000);
        }
      }
      ++self.$scope.retry_attempts;
    };

    this.hmrService.get(this.hmr_external_id, handleSuccess, handleError);
  }

  show_message() {
    if (this.$scope.connection_status === "FAILED") {
      this.$scope.show_toast("The connection could not be reestablished. Please try again later.", "alert-danger");
    }
    else {
      let message = "Unstable internet connection. Retrying in";
      if (this.$scope.delay >= 3600) {
        message += " " + Math.floor(this.$scope.delay / 3600) + "h";
      }
      if (this.$scope.delay >= 60) {
        message += " " + Math.floor(this.$scope.delay / 60) % 60 + "m";
      }
      message += " " + this.$scope.delay % 60 + "s";

      if (this.$scope.connection_status === "UNSTABLE") {
        message = [
          "Having trouble reestablishing the connection to the server.",
          "Please check your internet connectivity before attempting anything else such as reloading the page.",
          message,
        ];
      }
      this.$scope.show_toast(message, "alert-warning");
    }
  }

  get_practice_address(hmr) {
    const keys = [
      'street_address_1',
      'street_address_2',
      'city',
      'state',
      'postcode',
      'country',
      'address_type',
    ];
    let practice_address = hmr.practiceAddress.split('^').slice(0, keys.length);

    if (practice_address.length === 1) {
      practice_address = [
        hmr.clinic.streetAddress,
        '',
        hmr.clinic.city,
        hmr.clinic.state,
        hmr.clinic.postcode,
      ];
    }

    return Object.fromEntries(keys.slice(0, practice_address.length).map((key, index) => [key, practice_address[index]]));
  }

  get_gp_contact(referral) {
    const gp_contact = {};

    if (referral) {
      const keys = [
        'display',
        'use_code',
        'equipment_type',
        'email_address',
        'country_code',
        'area_code',
        'phone_number',
        'extension',
        'text',
      ];
      const contacts = referral.senderComms.split('~');

      contacts.forEach((contact) => {
        const parts = contact.split('^').slice(0, keys.length);
        const parts_obj = Object.fromEntries(keys.slice(0, parts.length).map((key, index) => [key, parts[index]]));

        if (parts_obj.display.length === 0 && parts.length > 6) {
          if (parts_obj.country_code.length) {
            parts_obj.country_code = `+${parts_obj.country_code}`;
          }
          const phone_number = `${parts_obj.area_code}${parts_obj.phone_number}`.replace(/^(0[^4\D])?(\d{4})(\d{4})(.*)/, '$1 $2 $3 $4');
          parts_obj.display = [parts_obj.country_code, phone_number].filter(part => part.length > 0).join(' ');
        }

        if (parts.length > 2) {
          let type = '';
          switch (parts_obj.equipment_type) {
            case 'PH':
              type = 'phone';
              break;
            case 'FX':
              type = 'fax';
              break;
          }

          gp_contact[type] = parts_obj.display;
          if (parts.length > 3 && parts_obj.email_address.length) {
            gp_contact.email = parts_obj.email_address;
          }
        }
      });
    }

    return gp_contact;
  }


  //noinspection JSUnusedGlobalSymbols
  get_ids(data, value = false) {
    return data.reduce((result, item) => {
      result[item.id] = value;
      return result;
    }, {});
  }

  is_boolean(value) {
    return typeof value === "boolean";
  }

  /**
   * Format a date
   * @param   {Date}      date
   *
   * @returns {Object}
   */
  formatDate(date) {
    if (!date || !(date instanceof Date)) {
      return null;
    }
    return {
      date: {
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate(),
      },
      time: {
        hour: 0,
        minute: 0,
      },
    };
  }

  /**
   * Save the HMR
   * Will automatically be called, at short intervals of time
   * @param   {Boolean}   submit
   * @param   {Function}  successCallback
   * @param   {Function}  errorCallback
   */
  save(submit = false, successCallback = null, errorCallback = null) {
    var self = this;

    var handleSuccess = function (response) {
      if (!response.data.error) {
        self.saving = false;
        self.processQueue();
        if (successCallback) {
          successCallback(response);
        }
      }
      else {
        handleError(response);
      }
    };

    var handleError = function (response) {
      self.saving = false;
      self.processQueue();
      if (errorCallback) {
        errorCallback(response);
      }
    };

    // Process concerns object
    this.hmr.hmrReport.patientConcerns = [];
    if (this.concerns.tooManyMeds) {
      this.hmr.hmrReport.patientConcerns.push({
        description: TOO_MANY_MEDS,
      });
    }
    if (this.concerns.expensive) {
      this.hmr.hmrReport.patientConcerns.push({
        description: EXPENSIVE,
      });
    }
    this.hmr.hmrReport.otherConcern = null;
    if (this.concerns.other && this.concerns.otherInput) {
      this.hmr.hmrReport.otherConcern = this.concerns.otherInput;
    }

    var hmr_structure = {
      id: true,
      hmrReport: true,
    };

    // Prepare the object to save
    let hmrToSave = angular.copy(this.hmr);
    hmrToSave = this.PhpPolyfillObject.fromObject(hmrToSave).intersectKey(hmr_structure);
    hmrToSave.hmrReport = this.PhpPolyfillObject.fromObject(hmrToSave.hmrReport).intersectKey(this.CommonData.REPORT_STRUCTURE);

    if (hmrToSave.hmrReport) {
      if (hmrToSave.hmrReport.dose_administration_aid) {
        if (hmrToSave.hmrReport.dose_administration_aid.has_daa !== true) {
          hmrToSave.hmrReport.dose_administration_aid.daa_type = null;
        }
        else if (hmrToSave.hmrReport.dose_administration_aid.has_daa !== false) {
          hmrToSave.hmrReport.dose_administration_aid.has_more_daa_info_benefit = null;
        }

        hmrToSave.hmrReport.dose_administration_aid.has_daa = this.yes_no_maybe(hmrToSave.hmrReport.dose_administration_aid.has_daa);
        hmrToSave.hmrReport.dose_administration_aid.has_more_daa_info_benefit = this.yes_no_maybe(hmrToSave.hmrReport.dose_administration_aid.has_more_daa_info_benefit);
      }

      if (typeof hmrToSave.hmrReport.dateConducted != "undefined") {
        hmrToSave.hmrReport.dateConducted = this.formatDate(hmrToSave.hmrReport.dateConducted);
      }
    }

    // If it's not already saving, go for it
    if (!this.saving) {
      this.callSave(hmrToSave, this.encryptedCvn, submit, handleSuccess, handleError);
    }
    // Otherwise, put it in the queue
    else {
      // If you are submitting, clear the queue first as you only need this call
      if (submit) {
        this.clearQueue();
      }
      this.savingQueue.push(function () {
        self.callSave(hmrToSave, self.encryptedCvn, submit, handleSuccess, handleError);
      });
    }
  }

  yes_no_maybe(value) {
    return (value === undefined || value === null)? null: Number(value);
  }

  /**
   * Actual call to the server
   * @param hmrToSave
   * @param submit
   * @param encryptedCvn
   * @param handleSuccess
   * @param handleError
   */
  callSave(hmrToSave, encryptedCvn, submit, handleSuccess, handleError) {
    this.saving = true;
    if (submit) {
      this.hmrService.submit(this.hmr_external_id, hmrToSave, encryptedCvn, handleSuccess, handleError);
    }
    else {
      this.hmrService.save(this.hmr_external_id, hmrToSave, handleSuccess, handleError);
    }
  }

  /**
   * Call when finished saving
   */
  processQueue() {
    if (this.savingQueue.length > 0) {
      this.savingQueue.shift()();
    }
  }

  /**
   * When submitting, delete any other saving in progress by clearing the queue
   */
  clearQueue() {
    this.savingQueue = [];
  }

  referral_pharmacist_is_active() {
    return [
      "active",
      "test",
    ].includes(this.hmr.assignedPharmacist.status.name);
  }

  /**
   * Go back to dashboard
   * NB: leaving the page automatically triggers the saving of the report
   */
  backToHmrStatus() {
    //noinspection JSCheckFunctionSignatures
    this.$state.go("app.hmr", {hmr_external_id: this.hmr_external_id});
  }

  /**
   * Clear concerns entered on screen
   */
  clearConcerns() {
    this.concerns = {
      none: true,
    };
  }

  /**
   * Mark "none" for concerns as false if another concern is checked
   */
  notNoneConcerns() {
    this.concerns.none = false;
  }

  patient_display_name() {
    return [
      this.hmr.referral.patientFirstname,
      this.hmr.referral.patientMiddlename,
      this.hmr.referral.patientLastname,
    ]
      .filter(function (name) {
        return name;
      })
      .join(decodeHtml("&nbsp;"));
  }

  patient_display_address() {
    let hmr_address = this.PhpPolyfillObject.fromObject({
      street_address_1: null,
      street_address_2: null,
      city: this.hmr.patientCity,
      state: this.hmr.patientState,
      postcode: this.hmr.patientPostcode,
    });
    let referral_address = this.PhpPolyfillObject.fromObject({
      street_address_1: this.hmr.referral.patientStreetAddress,
      street_address_2: this.hmr.referral.patientStreetAddress2,
      // TODO These are correct. Rearrange them when the field order in the referral table is fixed.
      city: this.hmr.referral.patientState,
      state: this.hmr.referral.patientPostcode,
      postcode: this.hmr.referral.patientCity,
    });

    return hmr_address.merge(referral_address.filter());
  }

  gp_display_name() {
    return [
      this.hmr.referral.senderFirstname,
      this.hmr.referral.senderMiddlename,
      this.hmr.referral.senderLastname,
    ]
      .filter(function (name) {
        return name;
      })
      .join(decodeHtml("&nbsp;"));
  }

  save_patient_and_gp_details(manual = false) {
    let self = this;

    let referral = this.PhpPolyfillObject.fromObject(angular.copy(this.hmr.referral));

    referral = referral.intersectKey(this.CommonData.REFERRAL_STRUCTURE);

    referral = this.UndefinedDataService.replace(referral);

    if (referral.patientPhone) {
      referral.patientPhone = referral.patientPhone.replace(/\D+/g, "");
    }

    if (referral.patientPhoneBusiness) {
      referral.patientPhoneBusiness = referral.patientPhoneBusiness.replace(/\D+/g, "");
    }

    if (referral.patientMedicare) {
      referral.patientMedicare = referral.patientMedicare.replace(/\D+/g, "");
    }

    let handleSuccess = function (response) {
      if (!response.data.error) {
        self.saving = false;
        self.hmr.has_complete_patient_details = response.data.data.hmr.has_complete_patient_details;
        if (self.hmr.has_complete_patient_details) {
          self.submitted = false;
        }
        self.processQueue();
      }
      else {
        handleError(response);
      }
    };

    let handleError = function (response) {
      self.saving = false;
      self.processQueue();
    };

    if (manual) {
      this.submitted = true;
    }

    let hmr = {
      referral: referral,
    };

    if (manual) {
      Object.assign(hmr, {
        patientDetailsCorrect: this.hmr.patientDetailsCorrect,
        gpDetailsCorrect: this.hmr.gpDetailsCorrect,
      });
    }

    this.hmrService.save_patient_details(this.hmr_external_id, hmr, handleSuccess, handleError);
  }

  /**
   * Ask the pharmacist to confirm by opening a modal allowing them to enter their CVN
   */
  confirmSubmission(form) {
    this.submitted = true;
    if (form.$valid && this.hmr.hmrReport.patientSignedPrivacyDocument) {
      this.openSubmissionModal();
    }
    else {
      this.focus_first_invalid_field();
    }
  }

  focus_first_invalid_field() {
    // TODO See https://stackoverflow.com/questions/20365121/set-focus-on-first-invalid-input-in-angularjs-form for more ideas
    let elem = angular.element("form .ng-invalid").first();
    if (elem.length > 0) {
      let element_top = elem.offset().top;
      let element_height = elem.outerHeight();
      //noinspection JSCheckFunctionSignatures
      let viewport_height = angular.element(window).height();

      angular.element("html, body").animate({
        scrollTop: element_top - (viewport_height - element_height) / 2,
      }, 500).promise().then(
        function () {
          elem.focus();
        }
      );
    }
  }

  /**
   * Open the modal to do the payment and submit
   */
  openSubmissionModal() {
    // Save one last time to make sure you have all the latest changes
    this.save();
    this.keepSaving = false;

    var self = this;
    var modal = this.uibModal.open({
      animation: true,
      backdrop: true,
      templateUrl: "hmrSubmitModal.html",
      controller: "HmrSubmitModalController",
      controllerAs: "HmrSubmitCtrl",
      resolve: {
        product_prices: function () {
          return self.product_prices[self.hmr.referralType.code];
        },
        patientName: function () {
          return self.hmr.referral;
        },
      },
    });

    modal.result.then(function (encryptedCvn) {
      // If agreed, submit
      self.encryptedCvn = encryptedCvn;
      self.submit();
    }, function () {
      // If not, back to editing mode, save again
      self.keepSaving = true;
    });
  }

  openRefundRequestModal() {
    let self = this;
    this.$scope.refund_modal.is_open = true;

    let refund_modal_instance = this.uibModal.open({
      animation: true,
      backdrop: true,
      templateUrl: "hmrRefundRequestModal.html",
      controller: "HmrRefundRequestModalController",
      controllerAs: "HmrRefundRequestCtrl",
      resolve: {
        type: function () {
          return "pharmacist";
        },
        hmr: self.hmr,
        refund_reasons: function (HmrService) {
          function handleSuccess(response) {
            if (response.data.success) {
              return response.data.data;
            }
            else {
              return handleError(response);
            }
          }

          function handleError(response) {
          }

          return HmrService.get_refund_reasons(handleSuccess, handleError);
        },
      },
    });

    refund_modal_instance.closed.then(function () {
      self.$scope.refund_modal.is_open = false;
    });
  }

  openSupportingFilesModal() {
    this.$scope.file_download_route = "app.referral-file-download";

    this.uibModal.open({
      animation: true,
      backdrop: true,
      templateUrl: "hmrSupportingFilesModal.html",
      controller: "HmrSupportingFilesModalController",
      controllerAs: "HmrSupportingFilesCtrl",
      resolve: {
        hmr: this.hmr,
        refund_reasons: {}
      },
      scope: this.$scope,
    });
  }

  download_original_referral(item = null) {
    if (this.referralModalOpen) {
      return;
    }

    let self = this;
    this.referralModalOpen = true;

    let handleSuccess = function (response) {
      let contentDisposition = response.headers("Content-Disposition");
      if (contentDisposition) {
        let filename = contentDisposition.replace(/^(attachment|inline); *filename=/, "");
        let blob = new Blob([response.data], {type: response.headers("Content-Type")});
        let anchor = document.createElement("a");
        anchor.href = URL.createObjectURL(blob);
        anchor.download = filename;
        anchor.target = "_blank";
        anchor.click();
        self.referralModalOpen = false;
      }
      else if (response.headers("Content-Type" === "application/json")) {
        let data = JSON.parse(new TextDecoder().decode(response.data));
        if (!data.success) {
          handleError(response);
        }
        else {
          self.saving = false;
          self.$scope.file_download_route = "app.original-referral-download";

          self.uibModal
            .open({
              animation: true,
              backdrop: true,
              templateUrl: "hmrOriginalReferralModal.html",
              controller: "HmrOriginalReferralModalController",
              controllerAs: "HmrOriginalReferralCtrl",
              resolve: {
                files: function () {
                  return data.data.files;
                },
              },
              scope: self.$scope,
            })
            .result.finally(function () {
              self.referralModalOpen = false;
            });
        }
      }
      else {
        handleError(response);
      }
    };

    let handleError = function (response) {
      self.saving = false;
      self.referralModalOpen = false;
    };

    this.hmrService.download_original_referral(this.hmr.id, item, handleSuccess, handleError);
  }

  /**
   * Formally submit the HMR
   */
  submit() {
    this.loadingSubmit = true;

    var self = this;

    var successCallback = function (response) {
      self.loadingSubmit = false;
      self.backToHmrStatus();
      self.messageService.add("success", response.data.message);
    };

    var errorCallback = function (response) {
      self.loadingSubmit = false;
      var message = response.data.message? response.data.message: "An error occurred.";
      var link = null;
      var linkTitle = null;

      if (response.data.data) {
        if (response.data.data.validationError) {
          message = response.data.data.validationError;
        }
        else if (response.data.data.paymentError && !response.data.data.systemError) {
          link = "app.pharmacist.billing";
          linkTitle = "You may need to update your payment details.";
        }
      }

      self.backToHmrStatus();
      self.messageService.add("danger", message, [linkTitle, link]);
      if (window.scrollTo) {
        window.scrollTo(0, 0);
      }

    };

    this.save(true, successCallback, errorCallback);
  }

  /**
   * Delete Medication
   * @param index of the clicked row
   */
  deleteMedication(index) {
    var item = this.hmr.hmrReport.hmrReportMedications[index];
    var name = item.drug? item.drug: "this medication";
    if (confirm("Are you sure that you want to remove " + name + " from the list ?")) {
      this.hmr.hmrReport.hmrReportMedications.splice(index, 1);
    }
  }

  /**
   * Add Medication
   */
  addMedication() {
    this.tmpMedication = {
      drug: "",
      strength: "",
      dose: "",
      reason: "",
    };
    this.hmr.hmrReport.hmrReportMedications.push(this.tmpMedication);
    this.tmpMedication = "";
  }

  //noinspection JSUnusedGlobalSymbols
  /**
   * Clear Medication
   */
  clearMedication() {
    this.tmpMedication = "";
  }

  /**
   * Delete Comment
   * @param index of the clicked row
   */
  deleteComment(index) {
    var item = this.hmr.hmrReport.hmrReportIssues[index];
    var extra = item.issue? " (" + item.issue + ")": "";
    if (confirm("Are you sure that you want to remove this comment" + extra + " from the list ?")) {
      this.hmr.hmrReport.hmrReportIssues.splice(index, 1);
    }
  }

  /**
   * Add Comment
   */
  addComment() {
    this.tmpComment = {
      issue: "",
      action: "",
    };
    this.hmr.hmrReport.hmrReportIssues.push(this.tmpComment);
    this.tmpComment = "";
  }
}

HmrController.$inject = $inject;

export default HmrController;



/** WEBPACK FOOTER **
 ** D:/server/Apache24/htdocs/hmr/app/HMRX_App/scripts/src/features/referral/controllers/hmr.controller.js
 **/